module.exports = __webpack_public_path__ + "static/media/YF82_3.e7c9eeb1.jpg";